import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Tue Sep 11 2018
 * @author LZe
 */
var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
      r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
      d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) {
    if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  }
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};

var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};

import { action, observable, runInAction } from 'mobx';
import { CompetitorLayer } from '../../transportLayers/competitor/CompetitorLayer';
import { BaseStore } from '../BaseStore';
import { StoreName } from '../StoreName';
/**
 * Competitor store
 */

export var CompetitorStore =
/*#__PURE__*/
function (_BaseStore) {
  _inherits(CompetitorStore, _BaseStore);

  function CompetitorStore() {
    var _this;

    _classCallCheck(this, CompetitorStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CompetitorStore).apply(this, arguments));
    _this.name = StoreName.Competitor;
    _this.competitorLayer = new CompetitorLayer();
    _this.list = new Map();

    _this.getAll = function () {
      return _this.competitorLayer.findAll().then(function (competitors) {
        runInAction(function () {
          competitors.forEach(function (competitor) {
            _this.list.set(competitor.id, competitor);
          });
        });
        return competitors;
      });
    };

    return _this;
  }

  return CompetitorStore;
}(BaseStore);

__decorate([observable, __metadata("design:type", Map)], CompetitorStore.prototype, "list", void 0);

__decorate([action, __metadata("design:type", Object)], CompetitorStore.prototype, "getAll", void 0);